// extracted by extract-css-chunks-webpack-plugin
module.exports = {"user-card-image":"user-card-image","content":"content","user-options":"user-options"};